export default __webpack_public_path__ + "static/media/banner-bg-mes-mulheres.541d42fb.jpg";